import React from "react";
import { Container } from "../../theme";

export interface LegalPageProps {
  title: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

export const LegalPage: React.FC<LegalPageProps> = ({ title, lastUpdated, children }) => {
  return (
    <div className="min-h-screen body-font bg-surface-bg text-ink">
      
      {/* Header */}
      <header className="bg-brand text-white py-6">
        <Container>
          <a 
            href="/" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors mb-4"
          >
            <span>←</span>
            <span>חזרה לאתר</span>
          </a>
          <h1 className="text-3xl md:text-4xl font-bold" dir="rtl">{title}</h1>
          {lastUpdated && (
            <p className="text-white/70 mt-2 text-sm" dir="rtl">
              עודכן לאחרונה: {lastUpdated}
            </p>
          )}
        </Container>
      </header>
      
      {/* Content */}
      <main className="py-12">
        <Container>
          <div 
            className="bg-white rounded-2xl shadow-sm border border-border p-6 md:p-10 max-w-4xl mx-auto prose prose-lg"
            dir="rtl"
            style={{ textAlign: 'right' }}
          >
            {children}
          </div>
        </Container>
      </main>
      
      {/* Simple Footer */}
      <footer className="py-6 border-t border-border bg-surface">
        <Container className="text-center">
          <a href="/" className="text-brand hover:underline">
            חזרה לדף הבית
          </a>
        </Container>
      </footer>
    </div>
  );
};

export default LegalPage;
